import BreezeBlock from "../../components/BreezeBlock";

export default function Vibe() {
  return (
    <section
      className="section section--palm"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* breeze-block screen behind the heading, set low so the type sits forward */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.08,
          zIndex: 0,
        }}
      >
        <BreezeBlock color="var(--c-blush)" size={64} />
      </div>

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="eyebrow" style={{ color: "var(--c-blush)" }}>
          The vibe
        </div>
        <h2
          className="display display--lg"
          style={{ marginTop: "1rem", maxWidth: "18ch" }}
        >
          warm, witty,
          <br />
          <em style={{ color: "var(--c-coral)" }}>friendship-first.</em>
        </h2>
        <p className="lead" style={{ marginTop: "1.5rem", opacity: 0.92 }}>
          Picture a sun-faded courtyard, a pitcher of something cold, and the
          kind of conversation that drifts from the book to your week to the
          ridiculous thing your boss said on Tuesday. That's the room we're
          building.
        </p>

        <div
          style={{
            marginTop: "3rem",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.5rem",
          }}
        >
          <VibeCard
            tone="Cozy"
            line="Small group. Real conversations. Nobody's grading you on annotations."
          />
          <VibeCard
            tone="Curious"
            line="One book a month across genres — romance one month, memoir the next."
          />
          <VibeCard
            tone="Kind"
            line="No gatekeeping, no hot takes for sport. We're here to like each other."
          />
        </div>
      </div>
    </section>
  );
}

function VibeCard({ tone, line }: { tone: string; line: string }) {
  return (
    <div
      style={{
        background: "rgba(251, 242, 230, 0.06)",
        border: "1px solid rgba(243, 202, 214, 0.25)",
        borderRadius: "var(--r-md)",
        padding: "1.75rem",
      }}
    >
      <div className="eyebrow" style={{ color: "var(--c-coral)" }}>
        {tone}
      </div>
      <p style={{ marginTop: "0.85rem", marginBottom: 0, lineHeight: 1.55 }}>
        {line}
      </p>
    </div>
  );
}
